import { render, staticRenderFns } from "./SortBy.vue?vue&type=template&id=1f730ba6&scoped=true"
import script from "./SortBy.vue?vue&type=script&lang=js"
export * from "./SortBy.vue?vue&type=script&lang=js"
import style0 from "./SortBy.vue?vue&type=style&index=0&id=1f730ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f730ba6",
  null
  
)

export default component.exports